import * as React from "react";
import { useCallback, useState } from "react";
import { DataLakeQuery } from "@graylog/enterprise-api";
import { Button, Alert } from "components/bootstrap";
import useFeature from "hooks/useFeature";
import DataLakeRoutes from "data-lake/Routes";
import useHistory from "routing/useHistory";
import { ConfirmDialog } from "components/common";
import { PREVIEW_JOB_STATUS } from "data-lake/preview/Constants";
import UserNotification from "util/UserNotification";
const PreviewLakeLogsButtonComponent = ({
  children = "Preview logs",
  bsStyle = void 0,
  bsSize = "xs",
  target = void 0,
  dataLakeId,
  urlParams,
  onClick = void 0
}) => {
  const history = useHistory();
  const [isLoadingActiveSearch, setIsLoadingActiveSearch] = useState(false);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const onNavigate = useCallback(() => {
    const url = `${DataLakeRoutes.PREVIEW}?dataLakeId=${dataLakeId}${urlParams ? `&${urlParams}` : ""}`;
    if (target === "_blank") {
      window.open(url, target);
    } else {
      history.push(url);
    }
  }, [dataLakeId, urlParams, target, history]);
  const toggleShowConfirmation = useCallback(() => {
    setShowConfirmDialog((cur) => !cur);
  }, []);
  const onClickHandler = useCallback(() => {
    onClick == null ? void 0 : onClick();
    setIsLoadingActiveSearch(true);
    DataLakeQuery.searchJobExecutionState().then(({ status }) => {
      if (status === PREVIEW_JOB_STATUS.running) {
        toggleShowConfirmation();
      } else {
        onNavigate();
      }
    }).catch((error) => {
      if (error.status === 404) {
        return onNavigate();
      }
      return UserNotification.error(error.message);
    }).finally(() => setIsLoadingActiveSearch(false));
  }, [onClick, onNavigate, toggleShowConfirmation]);
  const onConfirm = useCallback(() => {
    DataLakeQuery.resetActiveQuery().then(() => onNavigate());
  }, [onNavigate]);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    Button,
    {
      bsSize,
      title: "Preview data lake logs",
      onClick: onClickHandler,
      disabled: isLoadingActiveSearch,
      bsStyle
    },
    children
  ), showConfirmDialog && /* @__PURE__ */ React.createElement(
    ConfirmDialog,
    {
      show: showConfirmDialog,
      onConfirm,
      onCancel: toggleShowConfirmation,
      title: "A preview search is currently running"
    },
    /* @__PURE__ */ React.createElement(Alert, { bsStyle: "warning" }, "A preview search is currently running. Continuing will cancel the ongoing search job. Do you want to proceed?")
  ));
};
const PreviewLakeLogsButton = ({
  bsSize = void 0,
  bsStyle = void 0,
  children = void 0,
  dataLakeId,
  target = void 0,
  urlParams,
  onClick = void 0
}) => {
  const featureIsEnabled = useFeature("data_lake_search");
  if (!featureIsEnabled) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(
    PreviewLakeLogsButtonComponent,
    {
      urlParams,
      bsStyle,
      bsSize,
      target,
      dataLakeId,
      onClick
    },
    children
  );
};
export default PreviewLakeLogsButton;
